module.exports = __webpack_public_path__ + "static/media/MOSFET Board 2 4-min.1b75c9fd.jpg";